// skills/gatherer/index.js
// Gatherer skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import { renderGathererUI, updateGathererUI, initGathererUI, toggleGathering, upgradeTool, switchTab } from './gathererUI.js';

/**
 * Gatherer skill configuration
 */
const gathererConfig = {
    id: 'gatherer',
    name: 'Gatherer',
    icon: '🌿',
    iconImage: 'assets/icons/skill_icons/gatherer.png',
    description: 'Gather pet food and rare awakening materials from various zones',

    // Tabs for sub-pages
    tabs: [
        { id: 'tier1', name: 'Tier 1', default: true },
        { id: 'tier2', name: 'Tier 2' },
        { id: 'tier3', name: 'Tier 3' }
    ],

    /**
     * Render the gatherer interface
     * @param {Object} params - Render params (tab, etc.)
     */
    render(params = {}) {
        const { tab = 'tier1' } = params;
        renderGathererUI({ tab });
    },

    /**
     * Update function called each game tick
     */
    update() {
        updateGathererUI();
    },

    /**
     * Initialization function called once when skill is first accessed
     */
    init() {
        initGathererUI();
    },

    /**
     * Cleanup function called when navigating away
     */
    cleanup() {
        // Nothing to cleanup for now
    }
};

// Self-register with skill registry
skillRegistry.register('gatherer', gathererConfig);

// Expose to window for onclick handlers (legacy support)
if (typeof window !== 'undefined') {
    window.gathererUI = {
        toggleGathering,
        upgradeTool,
        switchTab
    };
}

export default gathererConfig;
